import React from 'react';
import { Shield, Database, FileText, AlertTriangle } from 'lucide-react';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../components/ui/tabs';
import { useSecurity } from './security/useSecurity';
import { BackupsTab } from './security/BackupsTab';
import { AuditLogsTab } from './security/AuditLogsTab';
import { MaintenanceTab } from './security/MaintenanceTab';
import { CreateBackupDialog } from './security/CreateBackupDialog';

const Security = () => {
  const s = useSecurity();

  return (
    <div className="space-y-6" data-testid="security-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
            <Shield className="h-6 w-6" />
            Security & Data Protection
          </h1>
          <p className="text-sm text-gray-600 mt-1">Manage backups, audit logs, and data maintenance</p>
        </div>
      </div>

      <Tabs defaultValue="backups" className="space-y-4">
        <TabsList className="grid w-full grid-cols-3 lg:w-[400px]">
          <TabsTrigger value="backups" className="flex items-center gap-2">
            <Database className="h-4 w-4" />
            Backups
          </TabsTrigger>
          <TabsTrigger value="audit" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Audit Logs
          </TabsTrigger>
          <TabsTrigger value="maintenance" className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            Maintenance
          </TabsTrigger>
        </TabsList>

        <TabsContent value="backups" className="space-y-4">
          <BackupsTab
            backupStats={s.backupStats}
            backups={s.backups}
            backupsLoading={s.backupsLoading}
            onRefresh={s.loadBackups}
            onCreate={() => s.setCreateBackupOpen(true)}
            onDownload={s.downloadBackup}
            onDelete={s.deleteBackup}
          />
        </TabsContent>

        <TabsContent value="audit" className="space-y-4">
          <AuditLogsTab
            auditSummary={s.auditSummary}
            failedActionsTotal={s.failedActionsTotal}
            auditFilters={s.auditFilters}
            setAuditFilters={s.setAuditFilters}
            availableActions={s.availableActions}
            availableResources={s.availableResources}
            auditLogs={s.auditLogs}
            auditTotal={s.auditTotal}
            auditLoading={s.auditLoading}
            onApplyFilters={s.loadAuditLogs}
          />
        </TabsContent>

        <TabsContent value="maintenance" className="space-y-4">
          <MaintenanceTab
            cleanupLoading={s.cleanupLoading}
            cleanupPreview={s.cleanupPreview}
            invalidProducts={s.invalidProducts}
            onPreview={s.previewCleanup}
            onRun={s.runCleanup}
          />
        </TabsContent>
      </Tabs>

      <CreateBackupDialog
        open={s.createBackupOpen}
        onOpenChange={s.setCreateBackupOpen}
        backupDescription={s.backupDescription}
        setBackupDescription={s.setBackupDescription}
        creatingBackup={s.creatingBackup}
        onCreate={s.createBackup}
      />
    </div>
  );
};

export default Security;
